export default __webpack_public_path__ + "static/media/Group7.f490475f.svg";